import { useContext } from 'react';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';
import { AppContext } from '@/context/AppContext';

const STYLES = {
  success: 'bg-[#00C48C]/10 border-[#00C48C]/30 text-[#00C48C]',
  error:   'bg-[#EF4444]/10 border-[#EF4444]/30 text-[#EF4444]',
  info:    'bg-[#0070F3]/10 border-[#0070F3]/30 text-[#60A5FA]',
};

const ICONS = { success: CheckCircle, error: XCircle, info: Info };

export default function Toast() {
  const { toasts, removeToast } = useContext(AppContext);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 pointer-events-none" data-testid="toast-container">
      {toasts.map(t => {
        const Icon = ICONS[t.type] || Info;
        return (
          <div
            key={t.id}
            data-testid={`toast-${t.type}`}
            className={`toast-enter pointer-events-auto flex items-center gap-3 rounded-lg border px-4 py-3 shadow-xl text-sm font-syne ${STYLES[t.type] || STYLES.info}`}
          >
            <Icon size={16} />
            <span>{t.message}</span>
            <button onClick={() => removeToast(t.id)} className="ml-2 opacity-60 hover:opacity-100">
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
